<template>
  <section class="home-mobile">
    <div v-if="!select_load_day && !choose_date" class="infinite-wrap">
      <bids-filter
        :quantity="bidsList.length || 0"
        @filter-changed="fetchBidsByFilter"
      />
      <el-collapse-transition>
        <bids-mobile
          v-if="getTypeView"
          :freights="freightTypesObj"
          :bids="bidsList"
          :page="page"
          @page="changePage"
          @next="loadDay"
          @fetch="fetchBids"
        />
      </el-collapse-transition>
      <el-collapse-transition>
        <new-bids-map-one-request
          v-if="!getTypeView"
          :freights="freightTypesObj"
          :bids="bidsList"
          @next="loadDay"
        />
      </el-collapse-transition>
    </div>
    <el-collapse-transition>
      <choose-day-mobile
        v-if="choose_date"
        :days="checkDates()"
        :info-sources="infoSourcesList"
        @next="dateChoosed"
        @back="backFromDate"
      />
    </el-collapse-transition>
    <el-collapse-transition>
      <load-day-mobile
        v-if="select_load_day"
        :bid="bid"
        :day="choosedDay(choosed_day)"
        :info-source="info_source_id"
        :freights="freightTypesObj"
        @back="backToDate"
        @response-complete="select_load_day = false"
      />
    </el-collapse-transition>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { isFutures } from '@/helpers/functions'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BidsFilter from './components/BidsFilter'
import BidsMobile from './components/BidsMobile'
import ChooseDayMobile from './components/ChooseDayMobile'
import LoadDayMobile from './components/LoadDayMobile/index'
import NewBidsMapOneRequest from '@/components/Maps/NewBidsMapOneRequest'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'NewHomeMobile',
  components: {
    BidsMobile,
    ChooseDayMobile,
    LoadDayMobile,
    BidsFilter,
    NewBidsMapOneRequest,
  },
  data() {
    return {
      bid: {},
      choosed_day: null,
      select_load_day: false,
      choose_date: false,
      load_point: [],
      perPage: 200,
      page: 1,
      infoSourcesList: [],
      info_source_id: 0,
    }
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
      bids: 'bids/getBids',
      getTypeView: 'bids/getTypeView',
    }),
    freightTypesObj() {
      return this.getLibObj('freightTypes')
    },
    bidsList() {
      let sort = false
      const driverBids = []
      const filledBids = this.bids.filter(b => {
        let entries = []
        const future_days = b.load_days
          ?.filter(day => isFutures(day.load_date))
          ?.map((d, i) => {
            d.index = i

            if (this.isDriverRole) {
              const arr = d.responses?.map(r => ({
                ...r,
                date: d.load_date,
                index: i,
              }))

              if (arr?.length > 0) {
                entries = entries.concat(arr)
                sort = true
              }
            }

            return d
          })

        if (future_days.length > 0) {
          b.future_days = future_days
          driverBids.push({ ...b, entries })
        }

        return future_days.length > 0
      })

      return this.isDriverRole && sort
        ? driverBids.sort(this.sorting)
        : filledBids
    },
  },
  async created() {
    this.initTypeView()
    this.fetchBidsKladrs()
    this.fetchBids()
    const { data } = await Responses.getInfoSources()

    this.infoSourcesList = data
  },
  methods: {
    ...mapActions('bids', ['fetchBidsKladrs']),
    ...mapMutations('bids', ['initTypeView']),
    fetchBids(requestData = {}) {
      const data = {
        ...requestData,
      }

      if (this.isDriverRole) {
        data.future_days = 1
        data.day_status = 0
      }

      if (this.getTypeView) {
        data.page = this.page
        data['per-page'] = this.perPage
      } else {
        data.enablePages = 0
      }
      this.$emit('fetch', data)
    },
    fetchBidsByFilter(filters) {
      this.page = 1
      this.fetchBids(filters)
    },
    sorting(a, b) {
      return (a.entries && !b.entries) || a.order > b.order ? -1 : 1
    },
    changePage(page) {
      this.page = page
      this.fetchBids()
    },
    choosedDay(chooseDay) {
      return this.checkDates()[chooseDay]
    },
    // открытие страницы выбора даты
    loadDay(bid) {
      this.bid = bid || {}
      this.choose_date = Boolean(bid)
      this.choosed_day = null
    },
    backFromDate() {
      this.choose_date = false
      this.select_load_day = false
    },
    // переход из окна выбора даты в окно ввода авто и водителя
    dateChoosed(day, info_source_id) {
      this.choosed_day = day
      this.info_source_id = info_source_id
      this.select_load_day = true
      this.choose_date = false
    },
    // возврат из окна ввода авто и водителя в окно выбора даты
    backToDate() {
      this.choose_date = true
      this.choosed_day = null
      this.select_load_day = false
    },
    checkDates() {
      return this.bid?.future_days || []
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"
$menu-height: 7rem

.home-mobile
  min-width: 320px
  .infinite-wrap
    height: calc(100vh - 50px)
    overflow: auto
  .el-table::before
    height: 0
  .err-p
    color: #ff0000
    font-size: 16px
    margin: 15px
  .mb-5
    margin-bottom: 5px
  .mob-btn
    width: 165px
    height: 30px
    font-weight: bold
    font-size: 12px
    padding: 0
    border-radius: 5px
    @include from(360px)
      width: 175px
    @include from(400px)
      width: 190px
      font-size: 13px
    @include from(420px)
      width: 200px
      font-size: 13px
    @include from(500px)
      height: 40px
      font-size: 14px
    &.el-button + .el-button
      margin: 0 15px 15px
    &.ld-btn
      width: 285px
      margin-bottom: 15px
    &.map-btn
      width: 75px
      font-size: 13px
      @include from(360px)
        width: 95px
      @include from(400px)
        width: 100px
        font-size: 14px
    &.change-btn
      width: 105px
    &.del-btn
      width: 135px
      background: #FF0000
  .map-el-dialog
    .el-dialog__body
      padding: 0 0 20px

  .bid
    position: relative
    padding: 1.6rem
    margin-bottom: 2rem
    font-family: 'Mulish', sans-serif
    background: #FFFFFF
    box-shadow: 0px 0px 1rem rgba(132, 132, 132, 0.15)
    border-radius: 1.2rem

    &__smalltext
      font-size: 1.2rem
      font-weight: 400
      line-height: 1.6rem
      color: #747474

    &__type
      width: fit-content
      padding: .2rem .8rem
      background: #F8F8F8
      border-radius: .4rem
      font-weight: 700
      font-size: 1.2rem
      line-height: 1.6rem
      color: #5C5C5C

    &__map
      position: absolute
      top: 1.6rem
      right: 1.6rem
      display: flex
      justify-content: center
      align-items: center
      width: 3.2rem
      height: 3.2rem
      background: $mainColor
      border-radius: .8rem
      color: #FFFFFF
      &:hover
        background: #00833C
      &:active
        background: #006421
      &-icon
        width: 1.6rem
        height: 1.6rem
        background: url('~@/assets/img/new-map.svg')
        background-size: contain
        background-repeat: no-repeat

    .arrow-btn
      width: 30px
      height: 30px
      font-size: 25px
      padding: 0
      @include from(500px)
        width: 40px
        height: 40px
        font-size: 35px

    &__main
      display: flex
      padding-top: 1.1rem
      border-bottom: 1px solid #D7D7D7
    .bid__direction
      margin-left: .8rem
      font-size: 1.9rem
      margin-bottom: 2rem
      font-weight: 700
      color: #181818
      &-load
        font-size: 1.6rem
        line-height: 2rem
      &-unload
        font-size: 1.4rem
        line-height: 1.8rem
      &-region
        margin-top: .2rem
      &-info
        display: flex
        margin: 1.2rem 0
        .info__item
          width: fit-content
          margin-right: .8rem
          padding: .1rem .8rem .2rem
          font-size: 1.2rem
          font-weight: 700
          line-height: 1.6rem
          border: 1px solid #D7D7D7
          border-radius: .6rem
          color: #181818
    .days
      display: flex
      margin: 1.4rem 0 1.6rem
      &__block
        width: 44%
        &.mod-right
          display: flex
          justify-content: flex-end
          width: 56%
        &-dates
          margin-top: .6rem
          font-size: 1.4rem
          font-weight: 700
          line-height: 1.8rem
          color: #181818
        &-prices
          margin-left: 1.5rem
          &:first-of-type
            margin-left: 0.5rem
          .title
            text-align: right
          .price
            margin-top: .4rem
            font-size: 1.6rem
            font-weight: 700
            line-height: 2rem
            color: #00833C

    .entries-block
      margin-bottom: 25px
      .entry-row
        margin-bottom: 15px
      b + b
        margin-left: 15px
        font-weight: 500
    .btn-block
      margin-bottom: 15px
    .bid-el-link
      margin-left: 5px
  .info-block
    margin-bottom: 30px
    text-align: center
    p
      font-size: 12px
      @include from(360px)
        font-size: 14px
      @include from(400px)
        font-size: 16px
    p:last-child
      margin-top: 15px
  .el-table__empty-text
    line-height: normal
  .middle-section
    padding: 0 10px 20px 20px
    .response
      cursor: pointer
      margin-bottom: 25px
      line-height: 20px
      @include from(360px)
        line-height: 22px
      @include from(400px)
        line-height: 24px
      @include from(500px)
        line-height: 28px
    p
      margin-bottom: 15px
  .dp_green
    color: #67C23A
  .dp_red
    color: #FF0000
  .el-button+.el-button
    margin: 5px 15px
  .section-load-day
    .closed
      color: #ff0000
      margin: 10px
  .loader
    height: 25vh
    color: #409EFF
.back
  position: fixed
  left: 0
  right: 0
  display: flex
  justify-content: center
  align-items: center
  height: 5rem
  background: #FFFFFF
  box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)
  border-radius: 0 0 12px 12px
  z-index: 100
  &__arrow
    position: absolute
    top: 1.3rem
    left: 1rem
    width: 2.4rem
    height: 2.4rem
    background: url("~@/assets/img/new-angle-left.svg")
    background-size: cover
    cursor: pointer
  &__title
    font-weight: 700
    font-size: 1.6rem
    color: #5C5C5C
.wrapper
  display: flex
  flex-direction: column
  min-height: 100vh
  height: -webkit-fill-available
  padding: 5rem 0 15.6rem
  .choice
    padding: 3.2rem 1.6rem 0
    &__title
      margin-bottom: 2.4rem
      font-weight: 800
      font-size: 2.2rem
      line-height: 3rem
      color: #181818
  .buttons
    position: fixed;
    bottom: 7rem
    left: 0
    right: 0
    display: flex
    justify-content: space-between
    padding: 1.6rem 0.8rem
    background: #FFFFFF
    box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)
    z-index: 50
    .button
      flex: 1
      display: flex
      justify-content: center
      align-items: center
      height: 4.4rem
      margin: 0 .8rem
      font-weight: 800
      font-size: 1.6rem
      line-height: 2.4rem
      border-radius: .8rem
      cursor: pointer
      &.grey
        background: #EFEFEF
        color: #8A8A8A
      &.primary
        background: $mainColor
        color: #FFFFFF
        &.disabled
          opacity: 0.3
          cursor: not-allowed
</style>
